import React from 'react';
import { trim, is } from 'ramda'
import InlineChord from '../components/InlineChord';

const MODE_LETTER = 'letter';
const MODE_CHORD = 'chord';
const MODE_SPECIAL_DIRECTIVE = 'special';

const nbsp = '\u00a0';
const tab = nbsp + nbsp;

const TAB_LENGTH = 2;

export default class SongParser {

    constructor(chordBrackets = '[]', specialSymbolBrackets = '{}', splitter = '\n') {
        this.startChordBracket = chordBrackets[0];
        this.endChordBracket = chordBrackets[1];

        this.startSpecialBracket = specialSymbolBrackets[0];
        this.endSpecialBracket = specialSymbolBrackets[1];

        this.lineSplitter = splitter;
    }

    parse(song) {
        let lines = [];

        if (is(String, song)) {
            song = song.split(this.lineSplitter);
        }

        song.forEach((row) => {
            if (!is(String, row)) {
                return;
            }

            lines.push(this.parseRow(trim(row)));
        });

        return lines;
    }

    parseRow(line) {
        let index = 0;
        let letterIndex = 0;

        let mode = MODE_LETTER;

        let text = '';
        let currentChord = '';

        let currentDirective = '';

        const chords = [];
        let chordPosition = letterIndex;

        while (index < line.length) {
            let letter = line[index];

            switch (mode) {
                case MODE_LETTER:
                    if (letter === this.startChordBracket) {
                        mode = MODE_CHORD;
                        chordPosition = letterIndex - 1;
                        currentChord = '';
                        break;
                    }

                    if (letter === this.startSpecialBracket) {
                        mode = MODE_SPECIAL_DIRECTIVE;
                        currentDirective = '';
                        break;
                    }

                    text += letter;
                    letterIndex++;

                    break;

                case MODE_CHORD:
                    if (letter === this.endChordBracket) {
                        chords.push({
                            chord: <InlineChord name={currentChord} className={null}/>,
                            position: chordPosition,
                            name: currentChord
                        });
                        mode = MODE_LETTER;
                        break;
                    }

                    currentChord += letter;
                    break;

                case MODE_SPECIAL_DIRECTIVE:
                    if (letter === this.endSpecialBracket) {
                        mode = MODE_LETTER;

                        if (currentDirective === 'tab') {
                            letterIndex += TAB_LENGTH;
                        }
                        text += tab;

                        break;
                    }

                    currentDirective += letter;
                    break;
                default:

            }

            index++;
        }

        text = text
            .replace(/\s/g, nbsp)
        ;

        chords.forEach((chord, index) => {
            if (index === 0) {
                return;
            }

            if (chord.position === chords[index - 1].position) {
                let canAddSpace = text.length > chord.position + 1 && text[chord.position + 1] === nbsp;
                if (canAddSpace) {
                    text = text.slice(0, chord.position + 1) + nbsp + text.slice(chord.position + 1);
                }
            }
        });

        return {
            chords,
            text
        };
    }
}
